import { transformColor } from '@amityeko/pbc-core/dist/utilities/color';
export function generateCustomColors(baseColor) {
    if (!baseColor)
        return {};
    return {
        '--private-color': baseColor,
        '--private-bg-color': transformColor(baseColor, 7, 1),
    };
}
//# sourceMappingURL=helpers.js.map